"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var forms_1 = require("@angular/forms");
var truck_reference_service_1 = require("../truck-reference.service");
var TruckReferenceCreateModalComponent = /** @class */ (function () {
    function TruckReferenceCreateModalComponent(formBuilder, truckReferenceService, dialogRef, data) {
        this.formBuilder = formBuilder;
        this.truckReferenceService = truckReferenceService;
        this.dialogRef = dialogRef;
        this.data = data;
        this.referenceForm = this.formBuilder.group({
            value: [''],
            licensePlate: [''],
            truckCode: [''],
            truckNumber: [''],
            truckType: [''],
        });
        this.mode = 'create';
    }
    TruckReferenceCreateModalComponent.prototype.ngOnInit = function () {
        if (this.data.model) {
            this.setFormFieldData(this.data.model);
        }
        this.mode = this.data.mode;
    };
    TruckReferenceCreateModalComponent.prototype.onSubmit = function () {
        var value = this.referenceForm.value;
        if (this.data.model) {
            value = __assign({}, this.data.model, this.referenceForm.value);
        }
        this.callback(this.truckReferenceService.save(value));
        this.dialogRef.close();
    };
    TruckReferenceCreateModalComponent.prototype.setFormFieldData = function (data) {
        this.referenceForm.patchValue(data);
    };
    return TruckReferenceCreateModalComponent;
}());
exports.TruckReferenceCreateModalComponent = TruckReferenceCreateModalComponent;
